import { DateRange } from '@mui/x-date-pickers-pro';
import { endOfDay, fromUnixTime, getUnixTime, startOfDay } from 'date-fns';
import { isNil, max, min } from 'ramda';

type InstantSearchRangeValue = number | undefined;

interface InstantSearchRange {
  min: InstantSearchRangeValue;
  max: InstantSearchRangeValue;
}

export const getInstantSearchDateRange = (range: InstantSearchRange): DateRange<Date> => {
  return [convertToDate(range.min), convertToDate(range.max)];
};

export const enforceInstantSearchDateRange = (
  range: InstantSearchRange,
  dateValues: [Date, Date],
): [number, number] => {
  const [startDate, endDate] = dateValues;
  const minTimestamp: number = getUnixTime(startOfDay(startDate));
  // Adding one day to include every record till 23:59.59 of the selected end date
  const maxTimestamp: number = getUnixTime(endOfDay(endDate));

  return [
    max(minTimestamp, range.min ?? Number.NEGATIVE_INFINITY),
    min(maxTimestamp, range.max ?? Number.POSITIVE_INFINITY),
  ];
};

export const getDateRange = (start: number, end: number): DateRange<Date> => {
  const startDate = startOfDay(fromUnixTime(start));
  const endDate = endOfDay(fromUnixTime(end));

  return [validateDate(startDate), validateDate(endDate)];
};

const validateDate = (date: Date) => (isNaN(date.getTime()) ? null : date);

export const convertToDate = (unixTimestamp: number | undefined) => {
  if (isNil(unixTimestamp)) return null;
  return fromUnixTime(unixTimestamp);
};

export const isEmptyDateRange = (dateRange: DateRange<Date>) => {
  return isNil(dateRange[0]) && isNil(dateRange[1]);
};
